import { Component, inject } from '@angular/core';
import { TranslateDirective } from '@ngx-translate/core';

import { NotificationComponent } from '../../../../components/notification/notification.component';
import { NotificationHeaderComponent } from '../../../../components/notification/notification-header.component';
import { InlineIconWrapperComponent } from '../../../inline-icon-wrapper/inline-icon-wrapper.component';
import { HrefDirective } from '../../../../directives/href/href.directive';
import { GamlAttestationAnalytics } from '../../../../services/gaml-attestation/gaml-attestation.analytics';

@Component({
  imports: [
    NotificationComponent,
    NotificationHeaderComponent,
    TranslateDirective,
    InlineIconWrapperComponent,
    HrefDirective
  ],
  selector: 'td-wb-gaml-halt-trade-global-notification-banner',
  templateUrl: './gaml-halt-trade-global-notification-banner.component.html'
})
export class GamlHaltTradeGlobalNotificationBannerComponent {
  private readonly gamlAttestationAnalytics = inject(GamlAttestationAnalytics);

  bannerAnalyticsEventLinkName: string;

  constructor(){
    this.bannerAnalyticsEventLinkName = this.gamlAttestationAnalytics.GAML_ATTESTATION_HALT_TRADE_BANNER_EVENT.link.name;
  }
}
